import React, { useState, useEffect } from 'react'
import { Panel, Row, Col, Icon, Table, ButtonGroup, IconButton } from 'rsuite'
import notification from '../../utils/notification'
import { doneLoading, startLoading } from '../../utils/loading'

export default function InfomaViewWidget({ schema, header, ...props }) {
  const { Column, HeaderCell, Cell } = Table
  const [attachFiles, setAttachFiles] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [expandedRowKeys, setExpandedRowKeys] = useState([])

  useEffect(() => {
    if (schema?.value?.length > 0) {
      setAttachFiles([...(schema.value || [])])

      let listId = []
      schema.value.forEach((item) => {
        if (item.id) {
          listId.push(item.id)
        }
      })
      setExpandedRowKeys(listId)
    }
  }, [schema])

  const onDownload = async (fileObj) => {
    startLoading()
    setIsLoading(true)
    try {
      // var file = await doDownload(fileObj.documentFilePath)
      // const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
      const url = fileObj.documentFilePath
      const link = document.createElement('a')
      link.href = url
      link.target = '_blank'
      link.setAttribute('download', fileObj.documentName)
      document.body.appendChild(link)
      link.click()
    } catch (e) {
      notification.open('error', {
        title: e?.response?.data?.errorMessage || 'ดาวน์โหลดไม่สำเร็จ',
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const onPreview = async (fileObj) => {
    startLoading()
    setIsLoading(true)
    try {
      //var file = await downloadFileByPath(fileObj.documentFilePath)
      const url = fileObj.documentFilePath
      const link = document.createElement('a')
      link.href = url
      link.target = '_blank'
      link.setAttribute('value', fileObj.documentName)
      document.body.appendChild(link)
      link.click()
    } catch (e) {
      notification.open('error', {
        title: e?.response?.data?.errorMessage || 'แสดงไม่สำเร็จ',
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  return (
    <Panel header={header} collapsible shaded defaultExpanded style={props.style}>
      <Row style={{ marginTop: 10 }}>
        <Col xs={24} sm={24} md={24} lg={24}>
          <Table
            autoHeight
            // height={300}
            minHeight={300}
            wordWrap
            bordered
            data={attachFiles}
            isTree
            defaultExpandAllRows
            rowKey="id"
            expandedRowKeys={expandedRowKeys}
            onExpandChange={(expanded, rowData) => {
              if (expanded) {
                setExpandedRowKeys((state) => [...state, rowData.id])
              } else {
                setExpandedRowKeys((state) => state.filter((item) => item !== rowData.id))
              }
            }}
          >
            <Column width={150} colSpan={3}>
              <HeaderCell>หมวดหมู่</HeaderCell>
              <Cell>
                {(rowData) => {
                  if (rowData.category) {
                    return rowData.category
                  }
                }}
              </Cell>
            </Column>

            <Column minWidth={300} flexGrow={1}>
              <HeaderCell>ชื่อเอกสาร</HeaderCell>
              <Cell>
                {(rowData) => {
                  if (rowData.documentName) {
                    return <span>{rowData.documentName}</span>
                  }
                }}
              </Cell>
            </Column>

            {/* <Column width={150} align="center">
              <HeaderCell>ประเภทเอกสาร</HeaderCell>
              <Cell>
                {(rowData) => {
                  if (rowData.documentTypeName) {
                    return rowData.documentTypeName
                  }
                }}
              </Cell>
            </Column> */}

            <Column width={240} align="center">
              <HeaderCell></HeaderCell>
              <Cell>
                {(rowData, index) => {
                  if (rowData.documentFilePath) {
                    return (
                      <ButtonGroup>
                        <IconButton
                          appearance="ghost"
                          icon={<Icon icon="eye" className="bt-gost-icon-radius" />}
                          onClick={(e) => onPreview(rowData)}
                          disabled={isLoading}
                        >
                          แสดง
                        </IconButton>
                        <IconButton
                          appearance="ghost"
                          icon={<Icon icon="download" className="bt-gost-icon-none-radius" />}
                          onClick={(e) => onDownload(rowData)}
                          disabled={isLoading}
                        >
                          ดาวน์โหลด
                        </IconButton>
                      </ButtonGroup>
                    )
                  }
                }}
              </Cell>
            </Column>
          </Table>
        </Col>
      </Row>
    </Panel>
  )
}
